<div class="main-container">
    <div class="promotion-form">
        <div class="first-row">
            <div>
                <h3>
                    New Promotion
                </h3>
            </div>
            <div class="button-container">
                <p-button [disabled]="promotionForm.invalid" label="Save" (onClick)="sendForm()"></p-button>
                <p-button label="Cancel" styleClass="p-button-warning" (onClick)="cancelCreate()"></p-button>
            </div>
        </div>

        <div [formGroup]="promotionForm" *ngIf="promotionForm">
            <div class="second-row">
                <div>
                    <p>From</p>
                    <input type="date" formControlName="from">
                </div>
                <div>
                    <p>
                        To
                    </p>
                    <input type="date" formControlName="to">
                </div>

                <div>
                    <p>
                        Programme Name
                    </p>
                    <select formControlName="studyProgram" (change)="change()">
                        <option *ngFor="let program of studyPrograms" [ngValue]="program">{{program.name}}</option>
                        <option value="-1">-- Add new programme</option>
                    </select>
                </div>

            </div>
            <ckeditor [editor]="Editor" formControlName="description"></ckeditor>
        </div>
    
        <p-dialog header="New Study Program" [(visible)]="display" [modal]="true">
            <div [formGroup]="programForm">
                <input formControlName="name">
                <button (click)="sendStudyProgram()">Save</button>
            </div>
        </p-dialog>
    </div>
</div>